/* eslint-disable react/require-default-props */
import {
  FlexGroup,
  FlexItem,
  InfiniteScroll,
  LoadingSpinner,
  Text,
} from '@antoree/ant-ui';
import { generateUId } from '@antoree/helpers';
import { memo } from 'react';
import { FormattedMessage } from 'react-intl';
import { Notification } from 'services/notifications';
import NotificationCard from './NotificationCard';

type Props = {
  notifications: Notification[] | undefined;

  dataLength: number;
  fetchNextPage: () => void;
  hasNextPage: boolean | undefined;
  height: number;
  closePopover?: () => void;
};

const NotificationBody = ({
  notifications,
  dataLength,
  fetchNextPage,
  hasNextPage,
  height,
  closePopover,
}: Props) => {
  return (
    <FlexGroup direction="column" className="ml-0">
      {dataLength > 0 && (
        <InfiniteScroll
          next={fetchNextPage}
          hasMore={hasNextPage ?? true}
          loader={
            <div className="flex flex-col items-center justify-center justify-items-center py-10">
              <LoadingSpinner />
            </div>
          }
          height={height}
          dataLength={dataLength}
        >
          {notifications && notifications?.length > 0 && (
            <Text className="font-bold text-xl">
              <FormattedMessage
                id="notification.body.new"
                defaultMessage="New"
              />
            </Text>
          )}
          <FlexItem>
            {notifications
              ?.filter(val => !val.isBefore)
              ?.map(item => (
                <NotificationCard
                  closePopoverNotification={closePopover}
                  notification={item}
                  key={+generateUId}
                  width="20rem"
                />
              ))}
          </FlexItem>
          <FlexItem>
            <Text className="font-bold text-xl">
              <FormattedMessage
                id="notification.body.before"
                defaultMessage="Before"
              />
            </Text>
            {notifications
              ?.filter(val => val.isBefore)
              ?.map(item => (
                <NotificationCard
                  closePopoverNotification={closePopover}
                  notification={item}
                  key={+generateUId}
                  width="20rem"
                />
              ))}
          </FlexItem>
        </InfiniteScroll>
      )}
    </FlexGroup>
  );
};

export default memo(NotificationBody);
